export default __webpack_public_path__ + "static/media/webcam_gif.c7ba29fc.gif";